import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
// import DownloadApp from '@components/downloadApp';
import classNames from 'classnames';
import { px2rem } from '@utils/px2rem';
import Avatar from '@components/avatar';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import RecommendedSearchInput from '../RecommendedSearchInput';
import { ensureBack } from '@utils/navigation';

const BACK_ICON_URL = 'https://vivo-oss-sz-bbs.oss-cn-shenzhen.aliyuncs.com/vivo-web/common/backicon.png';

interface H5HeaderProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    nav?: any;   // 导航数据
    navClick?: any; // 导航点击事件
    loginClick?: any    // 登录
    showDownloadApp?: boolean;  // 是否显示app下载入口
    avatar?: string;
    nickname?: string;
    closeAppDownloadEnter?: any
    navCurrentIndex?: any
    handleSetState?: any
    isShowHeader?: any  // 是否显示header，往下滚动的时候不显示，往上滚动的时候显示
    searchConfirm?: Function
    searchValue?: any   // 搜索框的值
    searchKeywords?: string[];
}
interface H5HeaderState {
    navShow?: any
    searchInputValue: string;  // 添加本地状态
    canGoBack: boolean;
}

type H5HeaderAllProps = H5HeaderProps & RouteComponentProps;

@inject('app', 'site', 'user')
@observer
class H5Header extends React.Component<H5HeaderAllProps> {
    state: H5HeaderState = {
        navShow: false,
        searchInputValue: this.props.searchValue || '',  // 从props初始化
        canGoBack: false,
    };
    componentDidMount() {
        this.updateBackButtonVisibility();
    }

    componentDidUpdate(prevProps: H5HeaderAllProps) {
        if (prevProps.searchValue !== this.props.searchValue) {
            this.setState({ searchInputValue: this.props.searchValue || '' });
        }
        if (
            prevProps.location.pathname !== this.props.location.pathname
            || prevProps.location.search !== this.props.location.search
        ) {
            this.updateBackButtonVisibility();
        }
    }

    // 浏览器首页和新标签页都不能作为站内上一页。支持 Navigation API 时，
    // 直接检查当前标签页中紧邻的上一条记录是否同域。
    hasInternalPreviousPage = () => {
        const navigationApi = (window as any).navigation;
        if (navigationApi?.currentEntry && typeof navigationApi.entries === 'function') {
            const currentIndex = navigationApi.currentEntry.index;
            const previousEntry = navigationApi.entries()[currentIndex - 1];

            if (!previousEntry?.url) {
                return false;
            }

            try {
                return new URL(previousEntry.url).origin === window.location.origin;
            } catch (error) {
                return false;
            }
        }

        // 旧浏览器无法可靠区分“同域链接在当前页打开”和“在新标签打开”，
        // 因此只认 React Router 创建的站内记录，避免错误展示。
        if (this.props.history.action === 'PUSH') {
            return true;
        }

        if (this.props.history.action === 'REPLACE') {
            return this.state.canGoBack;
        }

        if (this.props.location.key) {
            return true;
        }

        return false;
    };

    // 仅在存在站内上一页时展示返回按钮。
    updateBackButtonVisibility = () => {
        const canGoBack = this.hasInternalPreviousPage();
        if (this.state.canGoBack !== canGoBack) {
            this.setState({ canGoBack });
        }
    };

    handleBackClick = () => {
        ensureBack(() => {});
    };


    // 输入框变化处理
    handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log(e.target.value, this.props.handleSetState, '改变了吗');
        const value = e.target.value;
        this.setState({ searchInputValue: value });
        this.props.handleSetState && this.props.handleSetState({ searchValue: value })
    };

    // 问题反馈列表：点击 header 搜索框跳转搜索页
    handleFeedbackListSearchClick = () => {
        this.props.history.push('/feedbackListSearch');
    };

    render() {
        const { site, app, user, nav, avatar, nickname = true, showDownloadApp, closeAppDownloadEnter, navCurrentIndex, loginClick, isShowHeader, searchValue, location, ...props } = this.props;
        let { navShow, searchInputValue, canGoBack } = this.state;
        const platform = app?.platform || 'h5';
        const isFeedbackList = location?.pathname === '/feedbackList' || location?.pathname === '/myFeedbackList';
        return <>
            {isShowHeader && <div className={styles.headerWrap}>
                {/* 下载app的入口 */}
                {/* {showDownloadApp && <DownloadApp closeAppDownloadEnter={closeAppDownloadEnter}></DownloadApp>} */}

                {/* h5 header */}
                <div className={styles.headerBox} style={{top: showDownloadApp ? px2rem(88) : '0'}}>
                    {canGoBack && (
                        <button
                            type="button"
                            className={styles.backButton}
                            aria-label="返回上一页"
                            onClick={this.handleBackClick}
                        >
                            <img src={BACK_ICON_URL} alt="" />
                        </button>
                    )}
                    {/* <img  src={`${BASE_IMG_URL}/common/h5_logo.png`} className={styles.headerLogo} onClick={()=> {
                        this.props.handleSetState?.({ navCurrentIndex: 'home' });
                        this.props.history.push(`/`);
                        
                    }} /> */}
                    <div
                        className={classNames(styles.searchBox, isFeedbackList && styles.searchBoxTrigger)}
                        onClick={isFeedbackList ? this.handleFeedbackListSearchClick : undefined}
                    >
                        {isFeedbackList ? (
                            <>
                                <img src={`${BASE_IMG_URL}/common/search.png`} alt="" className={styles.searchIcon} />
                                <span className={styles.searchTriggerText}>搜索问题</span>
                            </>
                        ) : (
                            <RecommendedSearchInput
                                value={searchInputValue}
                                keywords={this.props.searchKeywords || []}
                                onChange={this.handleSearchChange}
                                onSearch={keyword => this.props.searchConfirm?.(keyword)}
                                inputClassName={styles.searchInput}
                                iconClassName={styles.searchIcon}
                            />
                        )}
                    </div>
                    <div className={styles.userBox} onClick={() => {
                        const { user, app } = this.props;
                        const platform = app?.platform || 'h5';
                        // 使用 checkLogin 检查登录状态，未登录会自动跳转到登录页
                        if (user?.checkLogin(platform)) {
                            // 已登录，跳转到个人中心
                            this.props.history.push(`/user/${user?.userInfo?.code}`);
                        }
                    }}>
                        {/* <img src={avatar || `${BASE_IMG_URL}/common/avatar.png`} alt="" className={styles.userAvatat} /> */}
                        <Avatar avatarUrl={avatar || user?.userInfo?.avatar} size={48} officialSize={20} titleMark={user?.userInfo?.titleMark} userCode={user?.userInfo?.code || 0}></Avatar>
                        {/* <span style={{marginLeft: 8, fontWeight: 500, fontSize: 18}}>{nickname}</span> */}
                    </div>
                    <img src={!navShow ? `${BASE_IMG_URL}/common/menu.png` : `${BASE_IMG_URL}/common/menu_close.png`} alt="" className={styles.menuIcon} onClick={()=> {
                        this.setState({
                            navShow: !navShow
                        })
                    }}/>
                </div>
                {navShow && <>
                    <div className={styles.navSlideList} style={{top: showDownloadApp ? px2rem(176) : px2rem(88)}}>
                        <div className={styles.navMask} onClick={() => {
                            this.setState({
                                navShow: false
                            })
                        }}></div>
                        <div className={styles.navBox}>
                            {/* 空状态，避免第一个导航被遮住 */}
                            {/* <div className={classNames(styles.navItem)}></div> */}
                            <div className={classNames(styles.navItem, navCurrentIndex === 'home' ? styles.navItemActive : '')} onClick={() => {
                                this.setState({
                                    navShow: !navShow
                                })
                                
                                this.props.navClick && this.props.navClick({}, 'home', 'home')
                                
                            }}>精选</div>
                            {nav?.[2]?.map((item: any, index:any) => (
                                <div className={classNames(styles.navItem, navCurrentIndex === index ? styles.navItemActive : '')} onClick={() => {
                                    this.setState({
                                        navShow: !navShow
                                    })
                                    
                                    this.props.navClick && this.props.navClick(item, 'topic', index)
                                }}>{item.topic?.alias || item.topic?.name}</div>
                            ))}
                            <div className={classNames(styles.navItem, navCurrentIndex === 'activity' ? styles.navItemActive : '')} onClick={() => {
                                this.setState({
                                    navShow: !navShow
                                })
                                this.props.navClick && this.props.navClick({}, 'activity', 'activity')
                            }}>福利活动</div>
                            <div className={classNames(styles.navItem, navCurrentIndex === 'goods' ? styles.navItemActive : '')} onClick={() => {
                                this.setState({
                                    navShow: !navShow
                                })
                                this.props.navClick && this.props.navClick({}, 'goods', 'goods')
                            }}>V币商城</div>
                            <div className={classNames(styles.navItem, navCurrentIndex === 'feedback' ? styles.navItemActive : '')} onClick={() => {
                                this.setState({
                                    navShow: !navShow
                                })
                                this.props.navClick && this.props.navClick({}, 'feedback', 'feedback')
                            }}>问题反馈</div>
                        </div>
                    </div>
                </>}
            </div>}
        </>
        
    }
}

export default withRouter(H5Header);
